<script setup lang="ts"></script>

<template>
  <div class="mx-auto max-w-7xl">
    <RouterView />
  </div>
</template>
